import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { cleanObjectEmptyFields, createQueryKey } from '@hero/utils';

import { services } from '../../services';

export const useGetCollections = (params = {}, options) => {
  return useQuery(
    createQueryKey(QUERY_KEYS.useGetCollectionsKey, params),
    () => {
      return services.list(cleanObjectEmptyFields(params));
    },
    options
  );
};
